import { Box } from '@mui/material';
import React, { ReactNode } from 'react';

export interface PageHeaderActionsBarProps {
  children: ReactNode;
}

const PageHeaderActionsBar: React.FC<PageHeaderActionsBarProps> = ({
  children,
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: { xs: 1, sm: 2 },
        paddingTop: 1,
      }}
    >
      {children}
    </Box>
  );
};

export default PageHeaderActionsBar;
